import { render, staticRenderFns } from "./MasterDataSimpleTimeModelPage.vue?vue&type=template&id=db2252ac&scoped=true&lang=pug&"
import script from "./MasterDataSimpleTimeModelPage.vue?vue&type=script&lang=ts&"
export * from "./MasterDataSimpleTimeModelPage.vue?vue&type=script&lang=ts&"
import style0 from "./MasterDataSimpleTimeModelPage.vue?vue&type=style&index=0&id=db2252ac&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db2252ac",
  null
  
)

export default component.exports